const mergeArr = (...args) => {
  let resultArr = [];
  for (let i = 0; i < args.length; i += 1) {
    if (i === 0) {
      resultArr = resultArr.concat(args[i]);
    } else {
      const resultArrCoppy = [].concat(resultArr);
      resultArr = resultArr.concat(args[i].filter((arg) => !resultArrCoppy.includes(arg)));
    }
  }
  return resultArr;
};

export default mergeArr;
